export default "__VITE_PUBLIC_ASSET__1fdadf79__"